"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplifiedFormat$ = exports.SimplifiedFormat$outboundSchema = exports.SimplifiedFormat$inboundSchema = void 0;
exports.simplifiedFormatToJSON = simplifiedFormatToJSON;
exports.simplifiedFormatFromJSON = simplifiedFormatFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.SimplifiedFormat$inboundSchema = z.object({
    house_number: z.string(),
    locality: z.nullable(z.string()),
    postcode: z.string(),
    street: z.nullable(z.string()),
    town: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "house_number": "houseNumber",
    });
});
/** @internal */
exports.SimplifiedFormat$outboundSchema = z.object({
    houseNumber: z.string(),
    locality: z.nullable(z.string()),
    postcode: z.string(),
    street: z.nullable(z.string()),
    town: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        houseNumber: "house_number",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SimplifiedFormat$;
(function (SimplifiedFormat$) {
    /** @deprecated use `SimplifiedFormat$inboundSchema` instead. */
    SimplifiedFormat$.inboundSchema = exports.SimplifiedFormat$inboundSchema;
    /** @deprecated use `SimplifiedFormat$outboundSchema` instead. */
    SimplifiedFormat$.outboundSchema = exports.SimplifiedFormat$outboundSchema;
})(SimplifiedFormat$ || (exports.SimplifiedFormat$ = SimplifiedFormat$ = {}));
function simplifiedFormatToJSON(simplifiedFormat) {
    return JSON.stringify(exports.SimplifiedFormat$outboundSchema.parse(simplifiedFormat));
}
function simplifiedFormatFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SimplifiedFormat$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SimplifiedFormat' from JSON`);
}
//# sourceMappingURL=simplifiedformat.js.map